export default __webpack_public_path__ + "static/media/logo-us-pottery-barn-kids.5891d95f.svg";